import React from 'react'
import styled from 'styled-components'
import { rem } from 'polished'
import BodyText from 'LuxKit/Typography/BodyText'
import { setSvgIconSize } from 'LuxKit/SvgIcon'
import Group from 'components/utils/Group'
import type { TripItineraryItem, TripItemWithoutDay } from 'tripPlanner/api/types'
import noop from 'lib/function/noop'
import ActivityIcon from './ActivityIcon'
import ActivityLocationAction from './ActivityLocationAction'
import ChatItemDropdown from './ChatItemDropdown'

const Card = styled.div`
  display: flex;
  align-items: flex-start;
  gap: ${rem(20)};
  padding: ${rem(16)};
  width: 100%;
  min-width: 0;
  border: 1px solid ${props => props.theme.palette.neutral.surface.lightForeground};
  border-radius: ${props => props.theme.borderRadius.L};
  background: ${props => props.theme.palette.neutral.surface.normalBackground};
`
const IconTile = styled.div`
  ${setSvgIconSize(25.12)}
  display: flex;
  align-items: center;
  justify-content: center;
  flex: 0 0 ${rem(90)};
  height: ${rem(90)};
  border-radius: ${props => props.theme.borderRadius.S};
  background: ${props => props.theme.palette.neutral.surface.lightBackgroundAlt};
`
const Description = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${rem(2)};
  min-width: 0;
  flex: 1;
  overflow-wrap: anywhere;
`
const Content = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: ${rem(8)};
  flex: 1;
  min-width: 0;
`

interface Props {
  item: TripItineraryItem | TripItemWithoutDay
  onDelete?: () => void
  onAskAI?: () => void
}

export default function ActivityPlaceholderCard({ item, onDelete = noop, onAskAI }: Props) {
  return <Card data-testid="activity-placeholder-card">
    <IconTile><ActivityIcon iconKey={item.iconKey} /></IconTile>
    <Content>
      <Group direction="horizontal" horizontalAlign="space-between" verticalAlign="start" fullWidth>
        <Description>
          <BodyText variant="large" weight="bold">{item.name}</BodyText>
          {item.description && <BodyText variant="small" colour="neutral-two">{item.description}</BodyText>}
        </Description>
        <ChatItemDropdown onDelete={onDelete} onAskAI={onAskAI} />
      </Group>
      <ActivityLocationAction item={item} />
    </Content>
  </Card>
}
